import React, { useState } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoginImage from "../../../Assets/images/Login_image.png";
import { AuthOHelper } from "../../../Common/Config";
import { ToastContainer, toast } from "react-toastify";
const ResetPassword = () => {
  const navigate = useNavigate();
  const [Payload, setPayload] = useState({});
  const [serachParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleSubmit = async () => {
    if (document.getElementById("passwordInput").checkValidity()) {
      setLoading(true);
      try {
        const result = await AuthOHelper().post(
          `/user/forgetPassword`,
          Payload
        );
        if (result.status === 200) {
          toast.success(result.data.message);
          setTimeout(() => {
            navigate("/login");
          }, 1500);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.error.name);
        setLoading(false);
      }
    }
    setValidated(true);
  };
  const handleChange = (e) => {
    setPayload({
      ...Payload,
      token: `bearer ${serachParams.get("verification")}`,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <>
      <ToastContainer />
      <Container className="py-5">
        <Breadcrumb>
          <Breadcrumb.Item>
            <small
              className="Login_BreadCrumbs_style"
              onClick={() => navigate("/")}
            >
              Home
            </small>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <small
              className="Login_BreadCrumbs_style"
              onClick={() => navigate("/category/MicrosoftOffice")}
            >
              Shop
            </small>
          </Breadcrumb.Item>
          <Breadcrumb.Item onClick={() => navigate("/login")}>
            <small className="Login_BreadCrumbs_style">Login</small>
          </Breadcrumb.Item>
          <Breadcrumb.Item onClick={() => navigate("/forgetPassword")}>
            <small className="Login_BreadCrumbs_style">Forget Password</small>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            <small className="Login_BreadCrumbs_style">
              Create New Password
            </small>
          </Breadcrumb.Item>
        </Breadcrumb>

        <Card className="Cart_Small_Card box_shadow">
          <Card.Body className="p-0">
            <Row>
              <Col md={6} xl={6} lg={6}>
                <img src={LoginImage} alt="AbouImg" className="Login_Img" />
              </Col>
              <Col
                md={6}
                xl={6}
                lg={6}
                className="About_Card_Para black_text p-5"
              >
                <Card.Title className="h6 my-4">Create New Password</Card.Title>
                <Form validated={validated}>
                  <Form.Group className="mt-4">
                    <Form.Label className="text-muted mt-4">
                      <small>New Password</small>
                    </Form.Label>
                    <Form.Control
                      required
                      type="password"
                      placeholder="password"
                      name="password"
                      id="passwordInput"
                      onChange={handleChange}
                      className="Login_InputFields"
                    />
                    <br />
                    <Button
                      className="SignIn_Btn mt-2 blue_bg"
                      onClick={handleSubmit}
                    >
                      {loading ? (
                        <span
                          class="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        ""
                      )}
                      Create Password
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default ResetPassword;
